import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/**
 * Dark / light theme switch.
 * variant="icon"  – compact icon button (default)
 * variant="full"  – icon + label
 */
export default function ThemeToggle({ variant = "icon", className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const Icon = isDark ? Sun : Moon;
  const label = isDark ? "Light" : "Dark";

  if (variant === "full") {
    return (
      <button
        type="button"
        onClick={toggle}
        className={`btn-ghost text-xs ${className}`}
        aria-label={`Switch to ${label.toLowerCase()} mode`}
        data-testid="theme-toggle-full"
      >
        <Icon size={14} /> {label} mode
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className={`p-2 border border-[var(--border)] text-zinc-300 hover:text-[var(--primary)] hover:border-[var(--primary)] transition-colors ${className}`}
      aria-label={`Switch to ${label.toLowerCase()} mode`}
      title={`Switch to ${label.toLowerCase()} mode`}
      data-testid="theme-toggle"
    >
      <Icon size={16} strokeWidth={1.75} />
    </button>
  );
}
